import { tv } from 'tailwind-variants';

export const searchSortStyles = tv({
  slots: {
    grid: 'grid grid-cols-2 gap-8 px-6 pb-6 pt-6',
    option:
      'group flex flex-col items-center gap-2 outline-none disabled:cursor-not-allowed disabled:opacity-50',
    iconBox:
      'flex size-12 items-center justify-center rounded-lg transition-colors group-focus-visible:ring-2 group-focus-visible:ring-green-400 group-focus-visible:ring-offset-2',
    icon: 'text-xl',
    label: 'w-[90px] text-center text-base leading-6 text-green-500',
  },
  variants: {
    selected: {
      true: {
        iconBox: 'bg-green-500 text-white',
        label: 'font-bold',
      },
      false: {
        iconBox: 'bg-green-100 text-green-500 hover:bg-green-200',
        label: 'font-normal',
      },
    },
  },
});
